import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';

export default function NavigationItem({
  item,
}) {
  const {pathname} = useLocation();
  const {
    linkName,
    linkIcon,
    linkPath,
    linkPathChildren,
    linkCustomClass,
  } = item;

  return (
    <li className={`app-header-item ${linkCustomClass}`}>
      <NavLink className={pathname.includes(linkPath) ? 'active' : ''} to={linkPath + linkPathChildren}>
        <span className={`app-header-item-icon ${linkIcon}`}></span>
        <span className="app-header-item-title">{linkName}</span>
      </NavLink>
    </li>
  )
}
